import BaseApi from '@/api/Base/BaseApi'
import {
  TaskType,
  GetTasksInProgressResponse,
  ExecuteTaskActionPayload,
  GetAllTasksInProgressResponse,
  GetWorkspaceAiTaskListResponse,
  GetBatchTaskListResponse
} from '@/api/Task/types'
import { GetTrainStatusResponse } from '@/api/ModelNode/types'
import { omitNilOrEmptyStringFromObject } from '@/utils/common'

const ROOT = '/ai-task'
const defaultPaginationOptions = {
  itemsPerPage: 25,
  page: 0,
  sortDir: 'desc',
  sortKey: 'createdAt',
}
export default class TaskApi extends BaseApi {
  getTasksInProgress(projectId: string) {
    return this.agent.get<GetTasksInProgressResponse>(`${ROOT}/project/${projectId}/list`)
  }

  getTaskStatus(jobId: string) {
    return this.agent.get<TaskType>(`${ROOT}/${jobId}`)
  }

  cancelTask(jobId: string) {
    return this.agent.put<TaskType>(`${ROOT}/${jobId}/cancel`)
  }

  executeTaskAction(payload: ExecuteTaskActionPayload) {
    const { jobId, status } = payload
    return this.agent.put<GetTrainStatusResponse>(`${ROOT}/${jobId}/actions`, { actionJobStatus: status })
  }

  getAllTasksInProgress() {
    return this.agent.get<GetAllTasksInProgressResponse>(`${ROOT}/list`)
  }

  getWorkspaceTaskList(workspaceId: string, payload?: any) {
    const { projectId, statuses } = payload ?? defaultPaginationOptions
    const params = omitNilOrEmptyStringFromObject({
      page: payload?.page ?? 0,
      num_per_page: payload?.itemsPerPage ?? 19,
      sort_key: payload?.sortKey ?? 'createdAt',
      projectId,
      statuses,
    })

    return this.agent.get<GetWorkspaceAiTaskListResponse>(`${ROOT}/workspace/${workspaceId}/list`, {
      params,
    })
  }

  completedTasksDeleteCheck(workspaceId: string) {
    return this.agent.get<number>(`${ROOT}/workspace/${workspaceId}/can-delete-completed`)
  }

  deleteCompletedTasks(workspaceId: string) {
    return this.agent.post<any>(`${ROOT}/workspace/${workspaceId}/delete-completed`)
  }

  getBatchTaskList(projectId: string, payload?: any) {
    const params = omitNilOrEmptyStringFromObject({
      page: payload?.page ?? 0,
      num_per_page: payload?.itemsPerPage ?? 20,
      sort_key: payload?.sortKey ?? 'createdAt',
      projectId: payload?.projectId,
      statuses: payload?.statuses,
    })
    return this.agent.get<GetBatchTaskListResponse>(`${ROOT}/batch/${projectId}/list`, {
      params,
    })
  }
}
